import { render, staticRenderFns } from "./ImgAnnouncementList.vue?vue&type=template&id=5e05fdb5&scoped=true"
import script from "./ImgAnnouncementList.vue?vue&type=script&lang=js"
export * from "./ImgAnnouncementList.vue?vue&type=script&lang=js"
import style0 from "./ImgAnnouncementList.vue?vue&type=style&index=0&id=5e05fdb5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e05fdb5",
  null
  
)

export default component.exports